module.exports = __webpack_public_path__ + "media/images/emblems/Fideris_wappen-24057003364232beb947f82740eec878.svg";